//set SEO args function
function setSeoArgs (seoValObj = {seo_title:'',name:'',seo_keywords:'',seo_description:''}){ 
  document.title = seoValObj.seo_title || seoValObj.name;
  document.querySelector('meta[name="keywords"]').setAttribute("content", seoValObj.seo_keywords || '');
  document.querySelector('meta[name="description"]').setAttribute("content", seoValObj.seo_description || '');
}
 
// 出参
export default {
  setSeoArgs
}


// WEBPACK FOOTER //
// ./src/utils/setSeoArgs.js